import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import '../../ReusableComponent/CIVIL/CivilTestToggle/Toggle.css';



function SectionIITestList({ handleSelectSubject, handlePlanSelect, subjects }) {
    return (
        <>
            <div className=''>
                <table className="table table-striped table-bordered table-hover text-center align-middle shadow-sm w-100 mt-2">
                    <thead className="table-primary">
                        <tr>
                            <th style={{ width: '10%' }}>Select</th>
                            <th style={{ width: '30%' }}>Item Name</th>
                            <th /*  colSpan={testPlans.length || "4"} */ >Select Number of Tests</th>
                        </tr>
                        {/* <tr className="table-light">
                                        <th></th>
                                        <th></th>
                                        {testPlans.map(test => (
                                            <th key={test.TestCount} >
                                                {test.TestCount} 
                                            </th>
                                        ))}
                                    </tr> */}
                    </thead>
                    <tbody>
                        {subjects?.map((subject, index) => (
                            <tr key={subject.Sn} className={index % 2 === 0 ? 'table-white' : 'table-light'}>
                                <td>
                                    <div className="d-flex justify-content-center">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                            checked={subject.checked}
                                            onChange={() => handleSelectSubject(subject)}
                                        />
                                    </div>
                                </td>
                                <td className="text-start fw-semibold w-50 ">{subject?.SubjectType}</td>
                                <td >
                                    <div className="d-flex justify-content-center w-100">
                                        <Select
                                            className="w-75 text-start"
                                            isDisabled={!subject.checked}
                                            placeholder='Select Test Count2'
                                            id='select_test'
                                            value={{ value: subject, label: subject.TestCount ? subject.TestCount + " Tests" : 'Select Number of Tests' }}
                                            onChange={(selectedOption) => handlePlanSelect(subject.Sn, selectedOption.value)}
                                            options={subject?.testPlans?.map((item) => ({ value: item, label: item.TestCount + " Tests" }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                    borderColor: '#17a2b8'
                                                })
                                            }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default SectionIITestList;

